import React, { useId } from 'react';
import { PHASE_STATE_LABELS, WORKLOAD_LABELS } from '../utils/phaseStatus';
import { displayText } from '../utils/displayText';

// A phase heading that expands and collapses its items: number, name, state
// pill (Current / Up next / Later / Done), workload chip, outcome and the
// action count. The count and outcome stay visible while collapsed, so a
// collapsed phase still says what it is for and how far it has got.
export default function PhaseSection({ phase, number, state, countLabel, expanded, onToggle, children }) {
  const bodyId = useId();
  const name = displayText(phase?.name) || `Phase ${number}`;
  const outcome = displayText(phase?.outcome);
  const stateLabel = PHASE_STATE_LABELS[state];
  const workload = WORKLOAD_LABELS[phase?.workload];

  return (
    <section className={`path-phase path-phase-${state || 'later'}`} aria-label={`Phase ${number}: ${name}`}>
      <button
        type="button"
        className="path-phase-head"
        aria-expanded={expanded}
        aria-controls={bodyId}
        onClick={onToggle}
      >
        <span className="path-phase-num" aria-hidden="true">{number}</span>
        <span className="path-phase-main">
          <span className="path-phase-name-line">
            <span className="path-phase-name">{name}</span>
            {stateLabel && <span className={`path-phase-state path-phase-state-${state}`}>{stateLabel}</span>}
            {workload && <span className="plan-item-chip">{workload}</span>}
          </span>
          {outcome && <span className="path-phase-outcome">{outcome}</span>}
        </span>
        {countLabel && <span className="path-phase-count">{countLabel}</span>}
        <span className="path-phase-caret" aria-hidden="true">{expanded ? '▾' : '▸'}</span>
      </button>
      <div id={bodyId} className="path-phase-items" hidden={!expanded}>
        {expanded ? children : null}
      </div>
    </section>
  );
}
